import React from 'react';
import { Link } from 'react-router-dom';

const ARIA_LABEL = 'Dedicated pages for property owners, realtors, and professionals';

/** Shared “For · Owners · Realtors · Professionals” strip on marketing landings. */
const ForAudienceNavStrip = ({
  variant = 'landing',
  activeAudience,
  onNavigate,
  onOwnersNavigate,
}) => {
  const afterNav = () => {
    onNavigate?.();
  };

  if (variant === 'landing') {
    const linkClass = (key) =>
      `landing-nav-partner-link${activeAudience === key ? ' landing-nav-partner-link--active' : ''}`;

    return (
      <div className="landing-nav-partners" aria-label={ARIA_LABEL}>
        <span className="landing-nav-partners-label">For</span>
        <Link
          to="/#for-owners"
          className={linkClass('owners')}
          onClick={(e) => {
            onOwnersNavigate?.(e);
            afterNav();
          }}
        >
          Owners
        </Link>
        <span className="landing-nav-partners-sep" aria-hidden>
          ·
        </span>
        <Link to="/for-realtors" className={linkClass('realtors')} onClick={afterNav}>
          Realtors
        </Link>
        <span className="landing-nav-partners-sep" aria-hidden>
          ·
        </span>
        <Link to="/for-professionals" className={linkClass('professionals')} onClick={afterNav}>
          Professionals
        </Link>
      </div>
    );
  }

  const rLink = (key, to, label) => (
    <Link
      to={to}
      className={`realtor-nav-audience-link${activeAudience === key ? ' is-active' : ''}`}
      onClick={afterNav}
    >
      {label}
    </Link>
  );

  return (
    <div className="realtor-nav-audience" aria-label={ARIA_LABEL}>
      <span className="realtor-nav-audience-label">For</span>
      {rLink('owners', '/#for-owners', 'Owners')}
      <span className="realtor-nav-audience-sep" aria-hidden>
        ·
      </span>
      {rLink('realtors', '/for-realtors', 'Realtors')}
      <span className="realtor-nav-audience-sep" aria-hidden>
        ·
      </span>
      {rLink('professionals', '/for-professionals', 'Professionals')}
    </div>
  );
};

export default ForAudienceNavStrip;
